import { Link } from "react-router-dom";
import { Send } from "lucide-react";
import { useStore } from "../context/StoreContext";
import { Banner } from "./common";
import { Button } from "./ui/button";
import { AccountantPackButton } from "./TaxPack";
import { yearEndStatus } from "../lib/finance";

// January only: nudge to build last year's accountant pack until it's made or dismissed
export function accountantReminderYear(state, now = new Date()) {
  if (now.getMonth() !== 0) return null;
  const year = now.getFullYear() - 1;
  if (state.taxChecklist?.[year]?.pack || state.accountantReminderDismissed === year) return null;
  return state.transactions.some((t) => t.date?.startsWith(String(year))) ? year : null;
}

export default function AccountantReminder() {
  const { state, update } = useStore();
  const year = accountantReminderYear(state);
  // The tax-season banner carries the same button while it's showing
  if (!year || yearEndStatus(state)?.year === String(year)) return null;
  return (
    <Banner icon={Send} testid="accountant-reminder">
      <b>Time to send your {year} accountant pack.</b> One PDF with your tax pack, mileage log and every receipt photo — on your phone it opens the share sheet so you can email or message it straight to your accountant.
      <div className="flex flex-wrap gap-2 mt-2">
        <AccountantPackButton year={year} size="sm" label="Create & send pack" testid="accountant-reminder-send" />
        <Button size="sm" variant="outline" asChild><Link to={`/reports?tab=tax&year=${year}`} data-testid="accountant-reminder-review">Review tax pack first</Link></Button>
        <Button size="sm" variant="ghost" onClick={() => update("Dismiss accountant reminder", (d) => (d.accountantReminderDismissed = year))} data-testid="accountant-reminder-dismiss">Not this year</Button>
      </div>
    </Banner>
  );
}
